import { ChatMarkdown } from "./ChatMarkdown";

export function ChatResponseText({
  text,
}: {
  text: string;
  status?: string | null;
}) {
  return <ChatMarkdown>{text}</ChatMarkdown>;
}
